import $ from 'jquery'

export default {
    name: 'import-excel-modal',
    components: {},
    props: {
        dispatch_action: String,
        emit_action: String,
        type_prestation: String,
		modal_toggler: Boolean
    },
    data() {
        return {
            files: [],
			is_loading: false,
			is_error: false,
			msg_error: '',

			// Import par lots (15/10/2026) : avancement affiché en pourcentage
			import_id: null,
			taille_lot: 0,
			import_en_cours: false,
			annulation_demandee: false,
			// Ligne à partir de laquelle reprendre après une erreur de lot (null = pas d'erreur)
			reprise_ligne: null,
			avancement: {
				pourcentage: 0,
				lignes_traitees: 0,
				total_lignes: 0
			}
        }
    },

	watch: {
		modal_toggler() {
			// Un import en cours continue même si la fenêtre est refermée puis rouverte
			if (this.import_en_cours) {
				return
			}
			// Import interrompu puis abandonné : le fichier déposé est supprimé côté serveur
			if (this.import_id && this.reprise_ligne !== null) {
				this.$store.dispatch('annulerImportPrestation', { import_id: this.import_id }).catch(() => {})
			}
			this.files = []
			this.is_error = false
			this.msg_error = ''
			this.reprise_ligne = null
			this.import_id = null
			this.avancement = { pourcentage: 0, lignes_traitees: 0, total_lignes: 0 }
		}
	},

    computed: {

    },

    mounted() {

    },

    methods: {
        handleFilesUpload(event) {
			this.msg_error = ''
			$('.err-msg').fadeOut()
			let uploadedFiles = this.$refs.files.files;

			console.log(event);
			console.log(typeof uploadedFiles);
			/*
			  Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}
		},


		importFile() {
			// Un seul import à la fois
			if (this.import_en_cours) {
				return
			}
			this.msg_error = ''
			this.is_loading = true

			let formData = new FormData();
			$('.err-msg').fadeOut()

			let err = 0

			if (this.files.length == 0) {
				err++
			}

			if (err == 0) {
				formData.append('file', this.files[0]);
				formData.append('type_prestation', this.dispatch_action);

				// Autorisation de notification demandée au clic, pour prévenir à la fin d'un long import
				this.demanderAutorisationNotification()

				// Dépôt du fichier, puis traitement lot par lot (aucune requête ne dépasse le max_execution_time)
				this.$store.dispatch('demarrerImportPrestation', { 'data': formData }).then((avancement) => {
					this.import_id = avancement.import_id
					this.taille_lot = avancement.taille_lot
					this.import_en_cours = true
					this.annulation_demandee = false
					this.majAvancement(avancement)
					this.traiterLots(avancement)
				}).catch((error) => {
					this.is_error = true
					this.is_loading = false
					this.msg_error = (error && error.response && error.response.status == 422)
						? "Le fichier n'est pas accepté. Vérifiez qu'il s'agit d'un fichier Excel (.xlsx, .xls, .csv)."
						: "Une erreur s'est produite lors de l'envoi du fichier. Merci de réessayer plus tard."
				})
			} else {
				// Afficher un message informant l'utilisateur de choisir un fichier
				$('.err-msg').fadeIn(500)
				this.is_loading = false
			}
		},

		/**
		 * Enchaîne les lots jusqu'à la fin. Un lot en échec est relancé deux fois (coupure réseau passagère) ; ensuite
		 * l'import s'arrête et peut être repris depuis la même ligne (un lot est enregistré entièrement ou pas du tout).
		 */
		async traiterLots(avancement) {
			let courant = avancement
			this.reprise_ligne = null
			this.msg_error = ''

			while (!courant.termine) {
				if (this.annulation_demandee) {
					return
				}

				let essais = 0
				let suivant = null
				while (suivant === null) {
					try {
						suivant = await this.$store.dispatch('importerLotPrestation', {
							import_id: this.import_id,
							debut: courant.prochaine_ligne
						})
					} catch (error) {
						essais++
						if (essais > 2 || (error && error.response && error.response.status == 404)) {
							this.arreterSurErreur(courant)
							return
						}
						await new Promise(resolve => setTimeout(resolve, 1500 * essais))
					}
				}

				courant = suivant
				this.majAvancement(courant)
			}

			this.terminerImport(courant)
		},

		majAvancement(avancement) {
			this.avancement = {
				pourcentage: avancement.pourcentage,
				lignes_traitees: avancement.lignes_traitees,
				total_lignes: avancement.total_lignes
			}
		},

		arreterSurErreur(avancement) {
			// Lignes du fichier (les données commencent à la ligne 3)
			const debut = avancement.prochaine_ligne
			const fin = Math.min(debut + this.taille_lot - 1, this.avancement.total_lignes + 2)

			this.import_en_cours = false
			this.is_loading = false
			this.is_error = true
			this.reprise_ligne = debut
			this.msg_error = "L'import s'est arrêté sur les lignes " + debut + " à " + fin + " du fichier. Les lignes précédentes sont enregistrées. Vous pouvez reprendre l'import à partir de ces lignes."
		},

		reprendreImport() {
			if (this.reprise_ligne === null || !this.import_id) {
				return
			}
			this.is_error = false
			this.is_loading = true
			this.import_en_cours = true
			this.annulation_demandee = false
			this.traiterLots({ termine: false, prochaine_ligne: this.reprise_ligne })
		},

		/**
		 * Annule l'import en cours : les lots déjà traités restent enregistrés, le fichier déposé est supprimé
		 */
		annulerImport() {
			if (!this.import_id) {
				return
			}
			this.annulation_demandee = true
			this.$store.dispatch('annulerImportPrestation', { import_id: this.import_id }).catch(() => {})

			const traitees = this.avancement.lignes_traitees
			this.import_en_cours = false
			this.is_loading = false
			this.reprise_ligne = null
			this.import_id = null
			this.warningToast("Import annulé : " + traitees + " ligne(s) déjà enregistrée(s).")
		},

		terminerImport(avancement) {
			this.import_en_cours = false
			this.is_loading = false
			this.import_id = null
			this.files = []
			var preview = document.getElementById('upfile'+this.dispatch_action);
			if (preview) {
				preview.value = "";
			}

			// La fenêtre n'existe plus si l'utilisateur a changé d'écran pendant l'import
			if (this.$refs.excel_modal) {
				this.$refs.excel_modal.click()
			}

			const message = "Importation terminée : " + avancement.total_lignes + " ligne(s) traitée(s) (" + this.type_prestation + ")."
			this.successToast(message);
			this.notifierFinImport(message)
			this.$emit(this.emit_action, avancement.total_lignes)
		},

		demanderAutorisationNotification() {
			if (typeof window === 'undefined' || !('Notification' in window)) {
				return
			}
			if (Notification.permission === 'default') {
				// Anciennes versions : requestPermission ne renvoie pas de promesse
				const demande = Notification.requestPermission()
				if (demande && demande.catch) {
					demande.catch(() => {})
				}
			}
		},

		/**
		 * Notification système (Electron / navigateur) : visible même si l'utilisateur a changé d'écran ou de fenêtre
		 */
		notifierFinImport(message) {
			if (typeof window === 'undefined' || !('Notification' in window) || Notification.permission !== 'granted') {
				return
			}
			try {
				new Notification('Import terminé', { body: message })
			} catch (e) {
				// Notification indisponible : le toast suffit
			}
		},
    }
}